<i18n>
{
	"en": {
		"error": "Error",
		"desc": "Order cannot be synced to TMS R10 due to these missing or invalid fields.",
		"consignor": "Consignor",
		"consignee": "Consignee",
		"despatchParty": "Despatch Party",
		"deliveryParty": "Delivery Party",
		"orderType": "Order Type",
		"etd": "ETD",
		"clerk": "Clerk"
		
	},
	"no": {
		"error": "Feil",
		"desc": "Kunne ikke synke oppdrag til TMS R10 grunnet manglende felt eller feil i felt.",
		"consignor": "Avsender",
		"consignee": "Mottaker",
		"despatchParty": "Henteadresse",
		"deliveryParty": "Leveringsadresse",
		"orderType": "Type Oppdrag",
		"etd": "ETD",
		"clerk": "Ansvarlig"
	}
}
</i18n>
<template>
	<t-dialog
		:isShown="isShown"
		:hasCancel="false"
		:title="$t('error')"
		icon="error"
		iconType="bp"
		iconColor="red"
		alwaysRememberFocus
		width="400px"
		@close="$emit('close')"
	>
		<div class="dialog-mid">
			<div>
				{{ $t('desc') }}
			</div>
			<ul>
				<li v-for="(item, index) in invalidList" :key="index">
					{{ $t(item) }}
				</li>
			</ul>
		</div>
	</t-dialog>
</template>
<script>

export default {
	name: 'MissingSyncRequirements',
	props: {
		isShown: Boolean,
		invalidList: Array,
	},
	data() {
		return {
			count: 1,
			newEtd: {
				date: '',
				hasTime: false,
				timeZone: 'Europe/Oslo',
				epoch: ''
			},
		};
	},
	computed: {
		
	},
	methods: {
		
	},
};
</script>

<style lang="scss" scoped>
.dialog-mid {
	display: grid;
	row-gap: 10px;
}
</style>

